import { IntegrationConfig } from 'modules/Integrations/domain'
import hubSpotLogo from './hubSpotLogo.svg'
import { HubSpotConfigurationManagement } from './HubSpotConfigurationManagement/HubSpotConfigurationManagement'
import { hubSpotConfigurationLoader } from './hubSpot.loader'
import { hubSpotConfigurationMutator } from './hubSpot.mutator'
import { HubspotIntegrationDetail } from './HubspotIntegrationDetail/HubspotIntegrationDetail'

export const hubSpotIntegrationConfig: IntegrationConfig = {
  logoUrl: hubSpotLogo,
  smallLogoUrl: hubSpotLogo,
  statusLabel: null,
  documentationUrl: 'https://docs.sequencehq.com/connectors/hubspot',
  features: {
    canDeleteLinks: true,
    canUninstall: true,
    isDocumentationOnly: false
  },
  title: 'HubSpot',
  description: `Sync deal and customer records from HubSpot.`,
  components: {
    detail: HubspotIntegrationDetail,
    management: HubSpotConfigurationManagement
  },
  communication: {
    configuration: {
      loader: hubSpotConfigurationLoader,
      mutator: hubSpotConfigurationMutator
    }
  }
}

export type HubSpotConfig = {
  /**
   * Whether the integration is 'paused'. Only editable on v1: v2 connects
   * already-enabled and stays that way, with the import stages below deciding
   * which deals become customers instead.
   */
  importCustomerWorkflow: boolean

  customerImportStages: string[]
  signedQuoteStage: string
  pdfSyncOnSign: boolean
  dealAmountSync: boolean

  // Read only.
  isV2Integration: boolean
}
